import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12 4C9.23858 4 7 6.23858 7 9C7 11.7614 9.23858 14 12 14C14.7614 14 17 11.7614 17 9C17 6.23858 14.7614 4 12 4ZM5 9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9C19 12.866 15.866 16 12 16C8.13401 16 5 12.866 5 9Z",
      fill: "#A466FC"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.0003 16C10.3326 16 8.69415 16.4389 7.2497 17.2725C5.80525 18.1062 4.60562 19.3053 3.77132 20.7494C3.49504 21.2276 2.8834 21.3913 2.40519 21.115C1.92698 20.8387 1.76328 20.2271 2.03956 19.7489C3.04944 18.0009 4.50153 16.5494 6.24996 15.5403C7.99839 14.5312 9.9816 14 12.0003 14C14.0191 14 16.0023 14.5313 17.7507 15.5404C19.4991 16.5496 20.9512 18.0011 21.961 19.7491C22.2373 20.2273 22.0736 20.8389 21.5953 21.1152C21.1171 21.3915 20.5055 21.2278 20.2292 20.7495C19.3949 19.3054 18.1953 18.1063 16.7509 17.2726C15.3065 16.4389 13.6681 16 12.0003 16Z",
      fill: "#A466FC"
    }, null, -1)
  ])))
}
export default { render: render }